export default __webpack_public_path__ + "static/media/profileImg5.7c1ba346.png";